<template>
    <b-badge v-if="prescription" :variant="variant" class="m-0">
        {{ label }}
    </b-badge>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Prescription, RefillStatusCode } from '@/models/Prescription';

/**
 * Displays a prescription's refill status and (when present) its substatus as a
 * single Bootstrap badge, e.g. "On Hold — Awaiting PA". The badge colour is
 * driven by the RefillStatusCode; the free-text substatus only contributes to
 * the label. The label reuses the Prescription.statusName getter so the
 * "Expired" override stays consistent with the rest of the app.
 */
@Component({ name: "PrescriptionStatusBadge" })
export default class PrescriptionStatusBadge extends Vue {
    @Prop({ required: true }) private prescription!: Prescription;

    get label(): string {
        const status = this.prescription.statusName;
        const subStatus = this.prescription.subStatusName;
        return subStatus ? `${status} — ${subStatus}` : status;
    }

    get variant(): string {
        if (this.prescription.isExpired) return 'danger';

        switch (this.prescription.status) {
            case RefillStatusCode.Refillable:
            case RefillStatusCode.AutoRefillable:
            case RefillStatusCode.TransferIn:
                return 'success';
            case RefillStatusCode.OnHold:
            case RefillStatusCode.AwaitingInsurance:
            case RefillStatusCode.Suspended:
                return 'warning';
            case RefillStatusCode.Canceled:
            case RefillStatusCode.Void:
            case RefillStatusCode.Discontinued:
            case RefillStatusCode.Expired:
                return 'danger';
            default:
                return 'secondary';
        }
    }
}
</script>
